// extracted by mini-css-extract-plugin
export default {"ResizeHandleOuter":"styles_ResizeHandleOuter__U8mNE","ResizeHandleInner":"styles_ResizeHandleInner__1amjP","Icon":"styles_Icon__aPzVc"};